import {
    REQUEST_ACTIVITY_HR_TIME_IN_ZONE,
    RECEIVE_ACTIVITY_HR_TIME_IN_ZONE,
    ACTIVITY_HR_TIME_IN_ZONE_FAIL
} from 'actions/ActionTypes.js';

const INITIAL_STATE = {
    isFetching: false,
    isFinish: true,
    entity: []
};

const requestActivityHrTimeInZones = (state) => {
    return {
        ...state,
        isFetching: true,
        isFinish: false
    };
};

const receiveActivityHrTimeInZones = (state, action) => {
    return {
        ...state,
        isFetching: false,
        isFinish: true,
        entity: {
            ...state.entity,
            [action.activityId]: action.activityHrTimeInZones
        },
        lastUpdated: action.receivedAt
    };
};

const activityHrTimeInZonesFail = (state) => {
    return {
        ...state,
        isFetching: false,
        isFinish: false
    };
};

const handlers = {
    [REQUEST_ACTIVITY_HR_TIME_IN_ZONE]: requestActivityHrTimeInZones,
    [RECEIVE_ACTIVITY_HR_TIME_IN_ZONE]: receiveActivityHrTimeInZones,
    [ACTIVITY_HR_TIME_IN_ZONE_FAIL]: activityHrTimeInZonesFail
};

export const getActivityHrTimeInZones = (state, activityId) => state.activityHrTimeInZones.entity[activityId];
export const getActivityHrTimeInZonesFinish = (state) => state.activityHrTimeInZones.isFinish;

export default function activityHrTimeInZones(state = INITIAL_STATE, action = {}) {
    const handler = handlers[action.type];

    if (!handler) return state;
    return handler(state, action);
}
